import './App.css'

import TextEditor from './components/TextEditor'

// Replace your code here
const App = () => <TextEditor />

export default App
